export default __webpack_public_path__ + "static/media/risk-handling.b0d7a39c.pdf";